export default __webpack_public_path__ + "static/media/map_mobile.d5334791.png";